import { render, staticRenderFns } from "./LeadSendService.vue?vue&type=template&id=4ad35280&"
import script from "./LeadSendService.vue?vue&type=script&lang=js&"
export * from "./LeadSendService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports